class Base {
    constructor(element) {
        this.element = element;
        this.children = new Collection();
    }
    
    appendChild(screen) {
        this.children.set(screen.model.uid, screen);
        this.element.appendChild(screen.element);
    }

    removeChild(screen) {
        this.element.removeChild(this.children.delete(screen.model.uid).element);
    }

    removeChildFirst() {
        this.element.removeChild(this.children.delete('_first').element);
    }

    removeChildLast() {
        this.element.removeChild(this.children.delete('_last').element);
    }
}